import { render, staticRenderFns } from "./PsPatients.vue?vue&type=template&id=19483062&scoped=true&"
import script from "./PsPatients.vue?vue&type=script&lang=js&"
export * from "./PsPatients.vue?vue&type=script&lang=js&"
import style0 from "./PsPatients.vue?vue&type=style&index=0&id=19483062&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19483062",
  null
  
)

export default component.exports